/** Menu AI Agent Hub: nguồn chung cho Navbar và navbarMenuRouteSync. */
export const AI_AGENT_BASE_PATH = '/thiet-lap/ai-agent';
export const AI_AGENT_SETTINGS_PATH = '/thiet-lap/ai-agent/cai-dat';

/** Mục hiện hành (menu con ở sidebar, `?tab=`). */
export const AI_HUB_SETTINGS_TABS = ['overview', 'agents', 'connect', 'knowledge', 'settings'] as const;
export type AiHubSettingsTabKey = (typeof AI_HUB_SETTINGS_TABS)[number];

/** Key cũ (link/bookmark trước khi gộp mục) → mục mới. */
export const AI_HUB_LEGACY_TABS = {
  general: 'settings',
  train: 'settings',
  deploy: 'settings',
  admin: 'settings',
  mcp: 'connect',
  experts: 'agents',
  test: 'agents',
  prompt: 'agents',
  monitor: 'overview', // biểu đồ mức dùng AI nằm ở Overview
  rules: 'settings', // Quy tắc nằm trong Settings (?group=rules)
} as const satisfies Record<string, AiHubSettingsTabKey>;

export const resolveAiHubTab = (raw: unknown): AiHubSettingsTabKey | null => {
  if (typeof raw !== 'string') return null;
  if ((AI_HUB_SETTINGS_TABS as readonly string[]).includes(raw)) return raw as AiHubSettingsTabKey;
  return (AI_HUB_LEGACY_TABS as Record<string, AiHubSettingsTabKey>)[raw] ?? null;
};

export const aiHubSettingsPath = (tab?: AiHubSettingsTabKey, query?: Record<string, string>): string => {
  const params = new URLSearchParams();
  if (tab && tab !== 'overview') params.set('tab', tab);
  if (query) {
    Object.entries(query).forEach(([k, v]) => {
      if (v) params.set(k, v);
    });
  }
  const qs = params.toString();
  return qs ? `${AI_AGENT_SETTINGS_PATH}?${qs}` : AI_AGENT_SETTINGS_PATH;
};

/** Các mục cài đặt — menu con «Cài đặt AI Agent» ở sidebar (key menu: `ai-agent-<key>`) và tiêu đề trang.
 *  `group: 'admin'`: nhóm Quản trị (cuối menu). `platformOnly`: chỉ Admin site nền tảng (TOPPION HOLDING).
 *  `everyone`: mọi người dùng mở được (không cần Admin). */
export const AI_HUB_SETTINGS_SECTIONS: readonly {
  key: AiHubSettingsTabKey;
  title: string;
  description: string;
  group?: 'admin';
  platformOnly?: boolean;
  everyone?: boolean;
}[] = [
  { key: 'overview', title: 'Overview', description: 'AI của công ty đang hoạt động thế nào: lượt dùng, token, lỗi theo ngày và theo mô hình; dữ liệu kết nối và còn gì cần thiết lập.' },
  { key: 'agents', title: 'Agents', description: 'Mọi agent AI của công ty — chọn một agent để thiết lập, sửa câu lệnh, xem kiến thức, chạy thử và lịch sử.' },
  { key: 'connect', title: 'MCP', description: 'Kết nối AI ngoài (Claude, Cursor, ChatGPT…) bằng khoá tự tạo: thao tác Action Plan và dữ liệu B1–B5 theo quyền của bạn — mọi lệnh ghi đều cần duyệt.', everyone: true },
  { key: 'knowledge', title: 'Data Studio', description: 'Tài liệu và nguồn dữ liệu cho AI theo module: kho dùng chung (site nền tảng) và kho riêng của công ty — công ty tự thêm tệp, API, trang web, MCP.', group: 'admin', platformOnly: true },
  { key: 'settings', title: 'Settings', description: 'Cài đặt chung: giới thiệu công ty, tính cách, bật/tắt AI, mô hình và hạn mức; Quy tắc AI: công cụ, nội dung, dữ liệu, trần token — áp ngay, có lịch sử và chạy thử.' },
];

export const aiHubSettingsMenuKey = (tab: AiHubSettingsTabKey) => `ai-agent-${tab}`;

/** Mục menu trong nhóm Cấu hình (chỉ Admin) — menu con theo từng mục cài đặt. */
export const AI_AGENT_MENU_ITEM = {
  key: 'ai-agent-cai-dat',
  path: AI_AGENT_SETTINGS_PATH,
  i18nId: 'bsc.menu.ai-agent.cai-dat',
  text: 'AI Coaching',
} as const;
